import { useTranslation } from 'react-i18next';
import './PartnersTab.scss';
import '../MastersAndPartnersTabs.scss';
import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';
import { sortByString } from 'utilities/dataSorters';
import Paragraph from 'components/TextComps/Paragraph';
import { MastersAndPartnersCard, MastersAndPartnersLoadingCard } from '../MastersAndPartnersCard/MastersAndPartnersCard';

export const PartnersTab = () => {
  const { t } = useTranslation();
  const partnersService = useServices().partnersService;

  const { data: partnersList, isPending } = useQuery({
    queryKey: ['partners'],
    queryFn: async () => {
      const response = await partnersService.getPartners();
      return sortByString(response, 'fullName', 'ASCENDING');
    },
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  return (
    <div className='masters-and-partners-tab'>
      <div className='masters-and-partners-header'>
        <h2>{t('PartnerGalleryTitle', { ns: 'partnersGallery' })}</h2>
        <Paragraph>
          <>{t('LearnMoreAboutPartners', { ns: 'partnersGallery' })}</>
        </Paragraph>
      </div>
      <div className='masters-and-partners-gallery'>
        {!isPending
          ? partnersList?.map((partner, i) => (
              <>
                <MastersAndPartnersCard
                  key={`partner-${i}`}
                  name={partner.fullName}
                  imgUrl={partner.imageUrl}
                  description={partner.description}
                />
              </>
            ))
          : Array.from(Array(10)).map((_, i) => <MastersAndPartnersLoadingCard key={`loading-partner-${i}`} />)}
      </div>
    </div>
  );
};
